import { render } from "./IconTwitter.vue?vue&type=template&id=be965a96&scoped=true&ts=true"
import script from "./IconTwitter.vue?vue&type=script&lang=ts"
export * from "./IconTwitter.vue?vue&type=script&lang=ts"

import "./IconTwitter.vue?vue&type=style&index=0&id=be965a96&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be965a96"]])

export default __exports__